import initialiseZoom from '../components/productZoom'
import { glidifyMob } from '../dom/glidify'
import { ready } from '../global/instantiate'
import { productInit } from '../sections/product'
import { setLastVisitedProductTitle } from '../sections/product/setLastVisitedProductTitle'
import productATCFixed from '../sections/productATCFixed'
import { initClickToViewGallery } from '../sections/productImagesZoom'
import { initProductUpsell } from '../sections/productUpsell'
import { initProductVideo } from '../sections/productVideo'

ready(() => {
  initialiseZoom('[data-main-product-image-wrapper]', 2)
  initClickToViewGallery()
  initProductUpsell()
  initProductVideo()
  productInit({}, (variant) => variant)
  // slickify()
  glidifyMob()
  productATCFixed()
  setLastVisitedProductTitle()
})
